import { tokenService } from '@/utils/auth/tokenService'

const imageCache = new Map<string, Promise<string>>()

const fetchWithAuthentication = (url: string, accessToken: string | null) => {
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}

const getProtectedImage = async (imageUrl: string | null | undefined) => {
  if (imageUrl) {
    if (imageCache.has(imageUrl)) {
      const cachedPromise = imageCache.get(imageUrl)
      if (cachedPromise) {
        return await cachedPromise
      }
    }

    const accessToken = tokenService.getAccessToken()
    if (!accessToken) {
      return ''
    }

    // 建立 promise 到 map
    // 減少同網址重複建立 blob url 以及切轉頁面時重複 fetch 的問題
    const fetchPromise = fetchWithAuthentication(imageUrl, accessToken)
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))

    imageCache.set(imageUrl, fetchPromise)

    return await fetchPromise
  }
  return ''
}

export { getProtectedImage }
